export const CHECKOUT_SESSION_PLACEHOLDER = '{CHECKOUT_SESSION_ID}';

const CHECKOUT_STATUS_PARAMS = ['billing', 'credits', 'subscription', 'session_id'];

export function buildCheckoutReturnUrl(baseUrl, statusParam, status, includeSessionId = false) {
  const url = new URL(baseUrl);

  CHECKOUT_STATUS_PARAMS.forEach((param) => url.searchParams.delete(param));
  url.searchParams.set(statusParam, status);

  if (includeSessionId) {
    url.searchParams.set('session_id', CHECKOUT_SESSION_PLACEHOLDER);
  }

  // Stripe requires its checkout-session placeholder to remain literal.
  return url.toString().replace(
    encodeURIComponent(CHECKOUT_SESSION_PLACEHOLDER),
    CHECKOUT_SESSION_PLACEHOLDER,
  );
}

export function buildLandingPaywallReturnUrl(prompt, origin = window.location.origin) {
  const url = new URL('/', origin);
  const trimmedPrompt = (prompt || '').trim();

  if (trimmedPrompt) {
    url.searchParams.set('billingPrompt', trimmedPrompt);
  }

  return url.toString();
}
